<template>
    <el-radio-group v-model="menuMobil" @change="handleChange" size="medium" class="full-width-radio-group no-rounded">
        <el-radio-button label="comisiones">
            Comisiones
        </el-radio-button>
        <el-radio-button label="destinatarios">
            Destinatarios
        </el-radio-button>
        <el-radio-button label="detalles">
            Detalles
        </el-radio-button>


    </el-radio-group>
</template>

<script>
export default {
    props: ['offset'],
    data() {
        return {
            menuMobil: localStorage.getItem('menuMobil') || 'comisiones', // Recuperar del localStorage o establecer valor predeterminado
        };
    },
    mounted() {
        window.addEventListener('scroll', this.handleScroll); // Escuchar el evento de scroll para actualizar el menú
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.handleScroll);
    },
    methods: {
        handleChange(newVal) {
            this.menuMobil = newVal;
            localStorage.setItem('menuMobil', newVal); // Guardar en localStorage al cambiar
            this.scrollToSection(newVal); // Llama al método para hacer scroll
        },
        scrollToSection(label) {
            let targetSection = '';
            let offset = 0;

            switch (label) {
                case 'detalles':
                    targetSection = '#detallesSection';
                    offset = this.offset === 'header' ? -210 : -90;
                  
                    break;
                case 'destinatarios':
                    targetSection = '#destinatariosSection';
                    offset = this.offset === 'header' ? -200 : -90;
                    break;
                case 'comisiones':
                    targetSection = '#comisionesSection';
                    offset = -250;
                    break;
                default:
                    break;
            }

            if (targetSection) {
                this.$scrollTo(targetSection, 500, { offset: offset });
            }
        },
        handleScroll() {
            const sections = [
                { id: 'comisionesSection', label: 'comisiones' },
                { id: 'destinatariosSection', label: 'destinatarios' },
                { id: 'detallesSection', label: 'detalles' },
               
            ];

            const scrollPosition = window.scrollY + 100; // Ajuste para reconocer cuando una sección está en vista

            sections.forEach(section => {
                const element = document.getElementById(section.id);
                if (element) {
                    const elementTop = element.offsetTop;
                    const elementBottom = elementTop + element.offsetHeight;

                    // Si la posición del scroll está dentro de la sección visible
                    if (scrollPosition >= elementTop && scrollPosition <= elementBottom) {
                        this.menuMobil = section.label;
                        localStorage.setItem('menuMobil', section.label); // Actualizar localStorage con la sección visible
                    }
                }
            });
        }
    }
};
</script>

<style scoped>
.full-width-radio-group {
    width: 100%;
}

.no-rounded .el-radio-button {
    border-radius: 0;
}
</style>
